module.exports = __webpack_public_path__ + "media/assets/services_manager/detail_test2-915e9d29a541f6f20db29c20005688bfe62dc33d0a936ad23fe044fb443c84c7.png";